import { Grid, Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { BasePlanModal } from 'v2/components/Shared/BasePlanModal';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { SubscriptionPlan as Plan } from 'v2/interfaces/product';

import { ActionsMenu } from './ActionsMenu';
import { BasePlanTable } from './BasePlanTable';
import { ChangePlanModal } from './ChangePlanModal';
import { LinksModal } from './LinksModal';
import { ListSubscriptionPlan } from './ListSubscriptionPlan';
import { FormContent } from '../FormContent';

import type IProduct from 'interfaces/IProduct';

type SubscriptionPlanProps = {
  product: IProduct;
  loading: boolean;
  updateProduct: (product: Partial<IProduct>) => void;
};

function SubscriptionPlan({ product, loading, updateProduct }: SubscriptionPlanProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedPlan, setSelectedPlan] = React.useState<Plan>();
  const [isChangePlanModalOpen, setIsChangePlanModalOpen] = React.useState(false);
  const [isPlanModalOpen, setIsPlanModalOpen] = React.useState(false);
  const [isLinksModalOpen, setIsLinksModalOpen] = React.useState(false);
  const history = useHistory();

  const userHasPlanModule = eduzzAccountsService.verifyUserHasBetaModule('planos_assinatura');

  function closeActions() {
    setAnchorEl(null);
  }

  function handleToCreatePlan() {
    history.push(`/producer/product/${product.id}/subscription-plan/create`, {
      product,
    });
  }

  function handleChangePlanModalClose() {
    setIsChangePlanModalOpen(false);
    setSelectedPlan(undefined);
  }

  function openPlanModal() {
    setIsPlanModalOpen(true);
  }

  function openLinksModal() {
    setIsLinksModalOpen(true);
    closeActions();
  }

  const handleActionsClick = React.useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>, plan: Plan) => {
    setAnchorEl(event.currentTarget);
    setSelectedPlan(plan);
  }, []);

  React.useEffect(() => {
    if (userHasPlanModule) return;
    history.push('/producer/product/myproducts');
  });

  const isVariation = product.isVariation();
  const saved = product.id !== 0;
  const hasBasePlan = !!product.plan_title;

  return (
    <Grid container spacing={2} alignItems='center'>
      <Grid item xs={12}>
        <FormContent title='Planos de assinatura' loading={loading}>
          <p>Cadastre e configure quantos planos forem necessários para o seu produto.</p>
          <Button
            id='edit-product-add-plan-button'
            onClick={isVariation && !saved ? openPlanModal : handleToCreatePlan}
            color='primary'
            variant='contained'
            type='submit'
            style={{ margin: '15px 0px' }}
          >
            Adicionar plano
          </Button>
          {saved && <ListSubscriptionPlan product={product} handleActionsClick={handleActionsClick} />}
          {!saved && !hasBasePlan && <Alert severity='warning'>Você precisa adicionar um plano para continuar.</Alert>}
          {!saved && hasBasePlan && <BasePlanTable product={product} openPlanModal={openPlanModal} />}
        </FormContent>
      </Grid>
      {isLinksModalOpen && (
        <LinksModal isOpen planId={selectedPlan?.plan_id} planTitle={selectedPlan?.plan_title} closeModal={() => setIsLinksModalOpen(false)} />
      )}
      {selectedPlan && (
        <>
          <ActionsMenu
            anchorEl={anchorEl}
            product={product}
            plan={selectedPlan}
            closeMenu={closeActions}
            openLinksModal={openLinksModal}
            openChangeModal={() => setIsChangePlanModalOpen(true)}
          />
          <ChangePlanModal isOpen={isChangePlanModalOpen} handleClose={handleChangePlanModalClose} plan={selectedPlan} productId={product.id} />
        </>
      )}
      {isPlanModalOpen && <BasePlanModal open handleClose={() => setIsPlanModalOpen(false)} product={product} updateProduct={updateProduct} />}
    </Grid>
  );
}

export { SubscriptionPlan };
